module.exports = __webpack_public_path__ + "img/img5.c9a737cd.png";